export type DashboardDetailDataType = "thread" | "manufacturer" | "part" | "task";

const THREAD_COMMON_COLUMNS = [
  "thread.omfNumber",
  "thread.pcnID",
  "thread.title",
  "thread.artNumber",
  "thread.omfShortDescr",
  "thread.dueDate",
  "thread.priority",
];

const MANUFACTURER_COMMON_COLUMNS = [
  "manufacturer.partNumber",
  "manufacturer.manufacturerPartNumberRaw",
  "manufacturer.nameRaw",
  "manufacturer.partner",
  "manufacturer.purchasePartNumber",
  "manufacturer.manufacturerPartNumber",
  "manufacturer.name",
  "manufacturer.lastUpdatedOn",
];

const PART_COMMON_COLUMNS = [
  "part.partNumber",
  "part.description",
  "part.obsolescenceManagement",
];

const TASK_COMMON_COLUMNS = [
  "post.omfNumber",
  "post.taskDescription",
  "post.taskResponsible",
  "post.taskCompleted",
  "post.completedAt",
  "post.create_time",
];

const CHART_DEPENDENT_COLUMNS: Record<string, string[]> = {
  omfStatusChart: ["thread.omfStatus"],
  openAndClosedChart: ["thread.omfStatus"],
  omApproachChart: ["thread.omApproach"],
  pcnSourceChart: ["thread.pcnSource"],
  mpnStatusChart: [
    "manufacturer.obsolescenceStatus",
    "manufacturer.obsolescenceStatus2years",
    "manufacturer.obsolescenceStatus4years",
    "manufacturer.obsolescenceStatus6years",
    "manufacturer.obsolescenceStatus8years",
  ],
  mpnReachChart: [
    "manufacturer.reachAffected",
    "manufacturer.reachSubstances",
  ],
  cpnStatusChart: [
    "part.obsolescenceStatus",
    "part.obsolescenceStatus2years",
    "part.obsolescenceStatus4years",
    "part.obsolescenceStatus6years",
    "part.obsolescenceStatus8years",
  ],
  cpnReachChart: ["part.reachAffected"],
};

const COMMON_COLUMNS_BY_DATA_TYPE: Record<DashboardDetailDataType, string[]> = {
  thread: THREAD_COMMON_COLUMNS,
  manufacturer: MANUFACTURER_COMMON_COLUMNS,
  part: PART_COMMON_COLUMNS,
  task: TASK_COMMON_COLUMNS,
};

export function getDashboardDetailColumnsForChart(
  chartKey: string,
  dataType: DashboardDetailDataType
) {
  return [
    ...COMMON_COLUMNS_BY_DATA_TYPE[dataType],
    ...(CHART_DEPENDENT_COLUMNS[chartKey] ?? []),
  ].filter((column, index, columns) => columns.indexOf(column) === index);
}
